export const LOAD_STATE = 'LOAD_STATE';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
export const SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING';
export const SET_TOTAL_LOADING = 'SET_TOTAL_LOADING';
export const SET_DIALOG_LOADING = 'SET_DIALOG_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const SET_FILTER = 'SET_FILTER';
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
